import type { IUserRoleDefinition } from './i-user-role-definition';
import type { UserRoleType } from './user-role-type';

export const userRoles: Record<UserRoleType, IUserRoleDefinition> = {
  admin: {
    role: 'admin',
    scope: 'global',
    title: 'Admin',
    description: 'Full access to all system management features.',
  },
  reviewer: {
    role: 'reviewer',
    scope: 'global',
    title: 'Reviewer',
    description: 'Can triage clips. No other admin access.',
  },
  viewer: {
    role: 'viewer',
    scope: 'global',
    title: 'Viewer',
    description: 'Read-only access to dashboards and reports.',
  },
  user: {
    role: 'user',
    scope: 'global',
    title: 'User',
    description: 'Standard app user. No admin dashboard access.',
  },
};
